// this file is generated by update_shopify_store_data.py at 2026-05-05 20:26:37.045511
var courses = [];